function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.293 3.293L6 7.586 1.707 3.293A1 1 0 00.293 4.707l5 5a1 1 0 001.414 0l5-5a1 1 0 10-1.414-1.414z",
  fill: "currentColor"
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PGcgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTEwLjI5MywzLjI5Myw2LDcuNTg2LDEuNzA3LDMuMjkzQTEsMSwwLDAsMCwuMjkzLDQuNzA3bDUsNWExLDEsMCwwLDAsMS40MTQsMGw1LTVhMSwxLDAsMSwwLTEuNDE0LTEuNDE0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9nPjwvc3ZnPg==";
export { SvgArrow as ReactComponent };